import { render, staticRenderFns } from "./InternalNotification.vue?vue&type=template&id=0ab51090&"
import script from "./InternalNotification.vue?vue&type=script&lang=js&"
export * from "./InternalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports